// https://github.com/angular/components/blob/master/src/cdk/keycodes/keycodes.ts

export const BACKSPACE = 8;
export const TAB = 9;
export const ENTER = 13;
export const ESCAPE = 27;
export const SPACE = 32;
export const END = 35;
export const LEFT_ARROW = 37;
export const UP_ARROW = 38;
export const RIGHT_ARROW = 39;
export const DOWN_ARROW = 40;
export const DELETE = 46;

export const KEY_A = 65;
export const KEY_C = 67;
export const KEY_L = 76;
export const KEY_N = 78;
export const KEY_R = 82;
export const KEY_S = 83;
export const KEY_V = 86;
export const KEY_X = 88;

export const SEMICOLON = 186;
export const COMMA = 188;
